const mutations = {
  'SET_CALENDARS' (state, { calendars }) {
    state.calendars = calendars
  },
  'SET_EVENTS' (state, { events }) {
    state.events = events
  }
}

export default mutations
